var map = {
	"./albania-round.svg": 92882,
	"./algeria-round.svg": 36247,
	"./argentina-round.svg": 40689,
	"./armenia-round.svg": 76467,
	"./australia-round.svg": 70024,
	"./austria-round.svg": 83523,
	"./azerbaijan-round.svg": 64159,
	"./bahamas-round.svg": 48322,
	"./belarus-round.svg": 16678,
	"./belgium-round.svg": 33113,
	"./bosnia-round.svg": 34956,
	"./brazil-round.svg": 25654,
	"./bulgaria-round.svg": 6615,
	"./cambodia-round.svg": 37458,
	"./canada-round.svg": 634,
	"./chile-round.svg": 35133,
	"./china-round.svg": 87179,
	"./colombia-round.svg": 64614,
	"./costa-rica-round.svg": 78562,
	"./croatia-round.svg": 6585,
	"./cyprus-round.svg": 75578,
	"./czech-republic-round.svg": 80498,
	"./denmark-round.svg": 7452,
	"./ecuador-round.svg": 28043,
	"./estonia-round.svg": 33635,
	"./ethiopia-round.svg": 70873,
	"./fake-antarctica-round.svg": 5634,
	"./finland-round.svg": 3010,
	"./france-round.svg": 8813,
	"./georgia-round.svg": 89246,
	"./germany-round.svg": 72009,
	"./ghana-round.svg": 69119,
	"./greece-round.svg": 55653,
	"./guatemala-round.svg": 72421,
	"./hong-kong-round.svg": 86918,
	"./hungary-round.svg": 37872,
	"./iceland-round.svg": 70916,
	"./india-round.svg": 53479,
	"./indonesia-round.svg": 71448,
	"./ireland-round.svg": 81447,
	"./israel-round.svg": 89852,
	"./italy-round.svg": 97431,
	"./japan-round.svg": 88154,
	"./kazakhstan-round.svg": 98162,
	"./kenya-round.svg": 43450,
	"./laos-round.svg": 44539,
	"./latvia-round.svg": 54753,
	"./libya-round.svg": 95765,
	"./lithuania-round.svg": 84791,
	"./luxembourg-round.svg": 59552,
	"./malaysia-round.svg": 18493,
	"./malta-round.svg": 75113,
	"./mexico-round.svg": 56561,
	"./moldova-round.svg": 46170,
	"./monaco-round.svg": 13053,
	"./morocco-round.svg": 33744,
	"./netherlands-round.svg": 63690,
	"./new-zealand-round.svg": 98008,
	"./nigeria-round.svg": 24239,
	"./north-macedonia-round.svg": 32067,
	"./norway-round.svg": 81622,
	"./pakistan-round.svg": 75661,
	"./panama-round.svg": 37316,
	"./paraguay-round.svg": 60452,
	"./peru-round.svg": 64898,
	"./philippines-round.svg": 67647,
	"./poland-round.svg": 8732,
	"./portugal-round.svg": 29638,
	"./romania-round.svg": 67675,
	"./russia-round.svg": 14503,
	"./serbia-round.svg": 20974,
	"./singapore-round.svg": 13608,
	"./slovakia-round.svg": 97600,
	"./slovenia-round.svg": 68509,
	"./south-africa-round.svg": 68646,
	"./south-korea-round.svg": 8308,
	"./spain-round.svg": 11057,
	"./sweden-round.svg": 17580,
	"./switzerland-round.svg": 90085,
	"./taiwan-round.svg": 12416,
	"./thailand-round.svg": 20313,
	"./tunisia-round.svg": 28773,
	"./turkey-round.svg": 61889,
	"./uae-round.svg": 95173,
	"./ukraine-round.svg": 36537,
	"./united-kingdom-round.svg": 17561,
	"./united-states-round.svg": 76386,
	"./uruguay-round.svg": 36118,
	"./venezuela-round.svg": 62191,
	"./vietnam-round.svg": 26778,
	"./your-moms-house-round.svg": 41547,
	"images/flags/albania-round.svg": 92882,
	"images/flags/algeria-round.svg": 36247,
	"images/flags/argentina-round.svg": 40689,
	"images/flags/armenia-round.svg": 76467,
	"images/flags/australia-round.svg": 70024,
	"images/flags/austria-round.svg": 83523,
	"images/flags/azerbaijan-round.svg": 64159,
	"images/flags/bahamas-round.svg": 48322,
	"images/flags/belarus-round.svg": 16678,
	"images/flags/belgium-round.svg": 33113,
	"images/flags/bosnia-round.svg": 34956,
	"images/flags/brazil-round.svg": 25654,
	"images/flags/bulgaria-round.svg": 6615,
	"images/flags/cambodia-round.svg": 37458,
	"images/flags/canada-round.svg": 634,
	"images/flags/chile-round.svg": 35133,
	"images/flags/china-round.svg": 87179,
	"images/flags/colombia-round.svg": 64614,
	"images/flags/costa-rica-round.svg": 78562,
	"images/flags/croatia-round.svg": 6585,
	"images/flags/cyprus-round.svg": 75578,
	"images/flags/czech-republic-round.svg": 80498,
	"images/flags/denmark-round.svg": 7452,
	"images/flags/ecuador-round.svg": 28043,
	"images/flags/estonia-round.svg": 33635,
	"images/flags/ethiopia-round.svg": 70873,
	"images/flags/fake-antarctica-round.svg": 5634,
	"images/flags/finland-round.svg": 3010,
	"images/flags/france-round.svg": 8813,
	"images/flags/georgia-round.svg": 89246,
	"images/flags/germany-round.svg": 72009,
	"images/flags/ghana-round.svg": 69119,
	"images/flags/greece-round.svg": 55653,
	"images/flags/guatemala-round.svg": 72421,
	"images/flags/hong-kong-round.svg": 86918,
	"images/flags/hungary-round.svg": 37872,
	"images/flags/iceland-round.svg": 70916,
	"images/flags/india-round.svg": 53479,
	"images/flags/indonesia-round.svg": 71448,
	"images/flags/ireland-round.svg": 81447,
	"images/flags/israel-round.svg": 89852,
	"images/flags/italy-round.svg": 97431,
	"images/flags/japan-round.svg": 88154,
	"images/flags/kazakhstan-round.svg": 98162,
	"images/flags/kenya-round.svg": 43450,
	"images/flags/laos-round.svg": 44539,
	"images/flags/latvia-round.svg": 54753,
	"images/flags/libya-round.svg": 95765,
	"images/flags/lithuania-round.svg": 84791,
	"images/flags/luxembourg-round.svg": 59552,
	"images/flags/malaysia-round.svg": 18493,
	"images/flags/malta-round.svg": 75113,
	"images/flags/mexico-round.svg": 56561,
	"images/flags/moldova-round.svg": 46170,
	"images/flags/monaco-round.svg": 13053,
	"images/flags/morocco-round.svg": 33744,
	"images/flags/netherlands-round.svg": 63690,
	"images/flags/new-zealand-round.svg": 98008,
	"images/flags/nigeria-round.svg": 24239,
	"images/flags/north-macedonia-round.svg": 32067,
	"images/flags/norway-round.svg": 81622,
	"images/flags/pakistan-round.svg": 75661,
	"images/flags/panama-round.svg": 37316,
	"images/flags/paraguay-round.svg": 60452,
	"images/flags/peru-round.svg": 64898,
	"images/flags/philippines-round.svg": 67647,
	"images/flags/poland-round.svg": 8732,
	"images/flags/portugal-round.svg": 29638,
	"images/flags/romania-round.svg": 67675,
	"images/flags/russia-round.svg": 14503,
	"images/flags/serbia-round.svg": 20974,
	"images/flags/singapore-round.svg": 13608,
	"images/flags/slovakia-round.svg": 97600,
	"images/flags/slovenia-round.svg": 68509,
	"images/flags/south-africa-round.svg": 68646,
	"images/flags/south-korea-round.svg": 8308,
	"images/flags/spain-round.svg": 11057,
	"images/flags/sweden-round.svg": 17580,
	"images/flags/switzerland-round.svg": 90085,
	"images/flags/taiwan-round.svg": 12416,
	"images/flags/thailand-round.svg": 20313,
	"images/flags/tunisia-round.svg": 28773,
	"images/flags/turkey-round.svg": 61889,
	"images/flags/uae-round.svg": 95173,
	"images/flags/ukraine-round.svg": 36537,
	"images/flags/united-kingdom-round.svg": 17561,
	"images/flags/united-states-round.svg": 76386,
	"images/flags/uruguay-round.svg": 36118,
	"images/flags/venezuela-round.svg": 62191,
	"images/flags/vietnam-round.svg": 26778,
	"images/flags/your-moms-house-round.svg": 41547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6436;